/**
 * Filters out parent_measure_ids that reference metrics which no longer exist.
 * This handles the case where an upstream metric is deleted but its ID remains
 * in a calculated metric's parent_measure_ids.
 */
export function filterValidParentMeasureIds(
  parentMeasureIds: string[],
  availableMeasureIds: string[],
): string[] {
  const availableSet = new Set(availableMeasureIds);
  return parentMeasureIds.filter(id => availableSet.has(id));
}
